'use strict';

exports.__esModule = true;

/* eslint-disable no-console,import/prefer-default-export */

var warn = exports.warn = (console.warn || console.log).bind(console, '[WARNING]:');